/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Category_CodeInputs */

const vi_expense_category_code = /** @type {(inputs: Expense_Category_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã`)
};

/**

* @param {Expense_Category_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_category_code = /** @type {((inputs?: Expense_Category_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Category_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_category_code(inputs)
});